import clsx from 'clsx';

//hooks
import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import PropTypes from 'prop-types';

import { POST, STORY } from '@/lib/posts/postTypes';
//lib
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import LoadMoreButton from '@/components/composite/Button/LoadMoreButton';
import { Illustration } from '@/components/composite/Illustration';
import Placeholder from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/Placeholder';
import { PostButton } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/PostButton';

//image
import illustrationEn from './../../../../../../../../public/images/illustrations/illustrations-empty-en.webp';
import illustrationEs from './../../../../../../../../public/images/illustrations/illustrations-empty-es.webp';
import illustrationFr from './../../../../../../../../public/images/illustrations/illustrations-empty-fr.webp';

const gridClassName = 'grid grid-col-1 xs:grid-cols-2 md:grid-cols-4 gap-6 lg:grid-cols-5 relative';

const PostsList = ({
    dataMedias,
    isLoadingInitialData,
    isLoadingMore,
    isLoadMore,
    loadMoreMedia,
    mutateMedias
}) => {
    const { t } = useTranslation();
    const { albumInfo } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const network = activeSocialProfile?.social_network_type;

    const typePost = albumInfo?.criteria?.album_type === 'stories' ? 'stories' : 'medias';

    if (isLoadingInitialData) {
        return (
            <div className={clsx('px-2 md:pb-2.5', gridClassName)}>
                {[...Array(20).keys()].map((item) => (
                    <Placeholder
                        key={item}
                        type={network === TIKTOK_BUSINESS || typePost === 'stories' ? STORY : POST}
                    />
                ))}
            </div>
        );
    }

    if (!dataMedias) {
        return (
            <div
                role="alert"
                className="flex h-64 flex-1 flex-col items-center justify-center space-y-3 p-8 px-2 text-sm">
                <p className="text-center">{t('errors:error_occured_fetch_data')}</p>
                <button className="text-icoBlue underline" onClick={() => mutateMedias(null)}>
                    {t('commons:try_again')}
                </button>
            </div>
        );
    }

    if (!dataMedias?.[0]?.[typePost]?.length) {
        return (
            <div className="flex h-64 flex-1 flex-col items-center justify-center space-y-3 px-2 text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                <Illustration
                    width={200}
                    height={200}
                    className="max-w-[200px]"
                    src={{ en: illustrationEn, fr: illustrationFr, es: illustrationEs }}
                />
                <span>{t('commons:no_posts')}</span>
            </div>
        );
    }

    return (
        <div className="px-2 md:pb-2.5">
            <div className={gridClassName}>
                {dataMedias.map((medias) => {
                    return medias?.[typePost]?.map((media) => {
                        return <PostButton key={media?.id} media={media} />;
                    });
                })}
            </div>
            {isLoadMore ? (
                <div className="mt-6 flex justify-center">
                    <LoadMoreButton isLoadingMore={isLoadingMore} loadMoreItems={loadMoreMedia} />
                </div>
            ) : null}
        </div>
    );
};

PostsList.propTypes = {
    isLoadingInitialData: PropTypes.bool
};

export default PostsList;
